import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './app.css';

import { UseQueryProvider } from './context/use-query-provider';
import { I18nProvider } from './context/i18n-provider';
import { ThemeProvider } from './context/theme-provider';
import { NotificationProvider } from './context/notification-provider';
import { OfflineProvider } from './context/offline-provider';

type AppProps = {
  children: React.ReactNode;
};

const App = ({ children }: AppProps) => (
  <I18nProvider>
    <UseQueryProvider>
      <ThemeProvider>
        <OfflineProvider>
          <NotificationProvider>
            <>{children}</>
          </NotificationProvider>
        </OfflineProvider>
      </ThemeProvider>
    </UseQueryProvider>
  </I18nProvider>
);

export default App;
